import React from 'react';

const courseplayer = (props) =>{
    if(!props.coursedetails){
        return <div>Loading...</div>
    }
     
    const courseURL = `https://www.youtube.com/embed/${props.coursedetails.id.videoId}`;
    return(
        <div className="CoursePlayer">
            <div className="ui embed">
                <iframe title="course player" src={courseURL} />
            </div>
            <div className="ui segment">
               <h4 className="ui header">{props.coursedetails.snippet.title}</h4>
               <p>{props.coursedetails.snippet.description}</p>
            </div>
        </div>
    )
}



export default courseplayer;